import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loadData } from "../../../functions/dataLoader";

const getContentIds = (block, journeys) => {
    return block.contents.map((content) => {
        const journeyList = journeys[content];
        return journeyList ? journeyList[0].id : null;
    });
};

const normalizeSchedules = (originData, journeys) => {
    originData.sort((a, b) => a.turn - b.turn);

    const entities = {};
    const hurdleNames = [];

    originData.forEach((schedule) => {
        schedule.befores.forEach((before) => {
            before.contentIds = getContentIds(before, journeys);
        });
        schedule.currents.forEach((current) => {
            current.contentIds = getContentIds(current, journeys);
        });
        schedule.afters.forEach((after) => {
            after.contentIds = getContentIds(after, journeys);
        });

        if (!entities[schedule.title]) {
            hurdleNames.push(schedule.title);
            entities[schedule.title] = [schedule];
        } else {
            entities[schedule.title].push(schedule);
        }
    });

    return { hurdleNames, entities };
};

export const initSchedules = createAsyncThunk("schedules/init", async () => {
    const [originData, journeys] = await Promise.all([loadData("schedules.json"), loadData("journeys.json")]);
    const normalized = normalizeSchedules(originData, journeys);
    return normalized;
});

const scheduleSlice = createSlice({
    name: "schedules",
    initialState: {
        hurdleNames: [],
        entities: {},
        status: "idle",
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(initSchedules.fulfilled, (state, action) => {
            state.hurdleNames = action.payload.hurdleNames;
            state.entities = action.payload.entities;
            state.status = "done";
        });
    },
});

export default scheduleSlice.reducer;
